import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Validator, Form } from '../widgets';

const EquipmentInteger = props => (
    <Form.Cell>
        <FormGroup>
            <Validator validation={props.validation}>
                <Form.Label>{props.name}{props.required ? <Validator.Mand /> : <></>}</Form.Label>
                <Form.Control size='sm' type="number" name={props.key_name} placeholder={props.placeholder} id={props.id} max={props.max} min={props.min}
                    value={props.value || ''} onChange={props.onChange} />
                <Validator.Text />
            </Validator>
        </FormGroup>
    </Form.Cell>
);

export default EquipmentInteger;